module.exports = __webpack_public_path__ + "media/images/communities/logos/ejc-c6ce3fbbb5feecc628ab3fe90fd89c5c.png";